/**
 * Spells a calendar `year_week` int as `2026 W35`. The year is always spelled
 * out — unlike a grid header, the text has no fiscal-year row to be read
 * against. A fiscal spelling comes from the response's calendar-read
 * `FiscalWeek`, never from arithmetic on the ISO key.
 */
export function formatYearWeek(yearWeek: number): string {
  const week = String(yearWeek % 100).padStart(2, "0");
  return `${Math.floor(yearWeek / 100)} W${week}`;
}
